<template>
    <div class="case-panel">
        <div class="case-panel__item case-panel__item--phase">
            <span class="case-panel__label">Prazo de hab/div</span>
            <ui-badge :text="phase.text" :tone="phase.tone" class="mt-1" />
            <span class="case-panel__hint">{{ phase.hint }}</span>
            <span v-if="summary.habdiv.start_date" class="case-panel__hint">início {{ formatDate(summary.habdiv.start_date) }}</span>
        </div>
        <div class="case-panel__item">
            <span class="case-panel__label">Habilitações recebidas</span>
            <strong>{{ summary.habilitations }}</strong>
        </div>
        <div class="case-panel__item">
            <span class="case-panel__label">Divergências recebidas</span>
            <strong>{{ summary.divergences }}</strong>
        </div>
        <div class="case-panel__item">
            <span class="case-panel__label">Credores com documentos solicitados</span>
            <strong>{{ summary.document_request_creditors }}</strong>
            <span class="case-panel__hint">de {{ summary.qgc_creditors }} credores no QGC</span>
        </div>
        <div class="case-panel__item">
            <span class="case-panel__label">Credores em análise de ofício</span>
            <strong>{{ summary.official_letter_creditors }}</strong>
            <span class="case-panel__hint" :class="{ 'case-panel__warn': summary.official_letters_pending }">
                {{ summary.official_letters_pending ? `${summary.official_letters_pending} análise(s) sem fundamentação` : "todas fundamentadas" }}
            </span>
        </div>
    </div>
</template>

<script>
import { formatCaseDate, habdivPhase } from "@/common/util/credit-analysis-case.util";

// Central de Creditos: painel do caso (prazo de hab/div, pedidos recebidos,
// documentos solicitados e analise de oficio), a partir do resumo dos cards.
export default {
    name: "CreditAnalysisCasePanel",

    props: {
        summary: { type: Object, required: true },
    },

    computed: {
        phase() {
            return habdivPhase(this.summary.habdiv);
        },
    },

    methods: {
        formatDate: formatCaseDate,
    },
};
</script>

<style scoped>
.case-panel {
    display: grid;
    grid-template-columns: 1.3fr repeat(4, minmax(0, 1fr));
    gap: 12px;
    margin-bottom: 16px;
}

.case-panel__item {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;
    padding: 12px 14px;
    border: 1px solid #e6e2ee;
    border-radius: 10px;
    background: #fafafc;
}

.case-panel__label {
    font-size: 12.5px;
    color: #6b6880;
}

.case-panel__item strong {
    font-size: 22px;
    font-weight: 600;
    color: #1d0533;
}

.case-panel__hint {
    font-size: 12px;
    color: #6b6880;
}

.case-panel__warn {
    color: #b45309;
}

@media (max-width: 1100px) {
    .case-panel {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
}
</style>
